const GA_MEASUREMENT_ID = 'G-MX0TETQD1N';

export function trackPageView(path) {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') {
    return;
  }

  window.gtag('config', GA_MEASUREMENT_ID, {
    page_path: path,
  });
}
